import { rankingItems } from '@/mocks/homeData';

const trendIcons: Record<string, string> = {
  up: 'ri-arrow-up-line text-green-500',
  new: 'ri-sparkling-line text-accent-500',
  stable: 'ri-subtract-line text-foreground-400',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            影视排行榜 · 热度榜单
          </h2>
          <p className="text-sm text-foreground-600 max-w-2xl mx-auto">
            实时更新的热门影视排行榜，基于全网讨论度与播放热度综合排名
          </p>
        </div>

        <div className="max-w-3xl mx-auto bg-background-50 border border-background-200/70 rounded-lg overflow-hidden">
          {rankingItems.map((item, index) => (
            <div
              key={item.id}
              className={`flex items-center gap-4 px-5 py-4 ${
                index < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
              } hover:bg-background-100 transition-colors cursor-pointer`}
            >
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                {item.rank <= 3 ? (
                  <span
                    className={`w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold text-background-50 ${
                      item.rank === 1
                        ? 'bg-primary-500'
                        : item.rank === 2
                          ? 'bg-accent-500'
                          : 'bg-secondary-500'
                    }`}
                  >
                    {item.rank}
                  </span>
                ) : (
                  <span className="text-sm font-semibold text-foreground-500">{item.rank}</span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-950 truncate">{item.title}</h3>
                <p className="text-xs text-foreground-500">{item.type}</p>
              </div>

              <div className="text-right flex-shrink-0">
                <div className="flex items-center gap-1 justify-end">
                  <span className="text-sm font-bold text-accent-600">{item.score}</span>
                  <i className={`text-xs ${trendIcons[item.trend] || trendIcons.stable}`}></i>
                </div>
                <p className="text-xs text-foreground-500">{item.hot}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}